function parsePhoneNumbers(phone) {
  const parts = phone.split('-');

  const tel = `+1${parts[0]}${parts[1]}${parts[2]}`;
  const vanityPhone = `1 (${parts[0]}) ${parts[1]} EMMA`

  return { tel, vanityPhone }
}

const Currency = {
  format: (n, options) => {
    const defaultOptions = {
      style: 'currency',
      currency: 'KRW',
      maximumFractionDigits: n % 1 === 0 ? 0 : 2
    }

    return new Intl.NumberFormat('ko-KR', {
      ...defaultOptions,
      ...options
    }).format(n)
  }
}

const Product = {
  renderPrice: (product) => {
    const price = Currency.format(product.price / 100)
    const originalPrice = Currency.format(product.compare_at_price / 100)

    const hasDiscount = product.compare_at_price > product.price

    return `${hasDiscount ?  "from" : ""}
          <span
            class="font-bold${hasDiscount ? " text-scarlet" : ""}"
          >${price}</span>
    
          <del
            class="product__original-price${!hasDiscount ? " hidden" : ""}"
          >${originalPrice}</del>
      `
  }
}

function isFunction(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
}

function isNumber(n) {
  return typeof n === 'number' && isFinite(n);
}

function waitUntil(conditionFunction) {
  const poll = resolve => {
    if (conditionFunction()) resolve();
    else setTimeout(_ => poll(resolve), 400);
  }

  return new Promise(poll);
}

async function requestCart(payload = {}, url = "/cart/add.js") {
  try {
    const state = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({ ...payload }),
    });
    return await state.json();
  } catch (e) {
    return null;
  }
}

function getCrossSellProducts() {
  return [...document.querySelectorAll('block-cross-sell')]
    .map(block => block.getAddToCartData())
    .filter(block => block.isAdded)
    .flatMap(block => [
      {
        quantity: block.quantity,
        id: block.crossSellVariantId,
        properties: {
          ...(block.hasGWP && { hasGWP: true }),
        },
      },
      ...(block.hasGWP
        ? [
          {
            quantity: block.quantity,
            id: block.crossSellVariantId,
            properties: {
              freeGift: true,
            },
          },
        ]
        : [])
    ]);
}
